// extracted by mini-css-extract-plugin
module.exports = {"root":"Main-root-ee4df41be5890ed4a7fdbd78d281d5eb"};